import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes } from '@fortawesome/pro-regular-svg-icons';
import SalesAndPromotionsDateRangePicker from './SalesAndPromotionsDateRangePicker';
import './SalesAndPromotionsPanelControls.scss';

const FILTERS = [
  {
    key: 'status',
    label: 'Sale status',
    options: [
      ['current', 'Current & upcoming'],
      ['live', 'Live now'],
      ['upcoming', 'Upcoming'],
      ['ended', 'Expired'],
      ['unavailable', 'Unavailable'],
      ['all', 'All history']
    ]
  },
  {
    key: 'placement',
    label: 'Placement',
    options: [
      ['all', 'All placements'],
      ['featured', 'Featured only'],
      ['standard', 'Not featured']
    ]
  },
  {
    key: 'visibility',
    label: 'Creator visibility',
    options: [
      ['all', 'All visibility'],
      ['visible', 'Not hidden'],
      ['hidden', 'Hidden only']
    ]
  }
];

const SalesAndPromotionsPanelControls = ({ filters, updateFilters }) => (
  <div className='sales-and-promotions-panel-controls'>
    <div className='search-field'>
      <FontAwesomeIcon icon={faSearch} />
      <input
        aria-label='Search sales'
        placeholder='Search brand, sale title, code, or domain'
        maxLength={255}
        value={filters.search}
        onChange={event => updateFilters({ search: event.target.value })}
      />
      {filters.search && (
        <button type='button' aria-label='Clear search' onClick={() => updateFilters({ search: '' })}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
      )}
    </div>
    <div className='filter-row'>
      {FILTERS.map(({ key, label, options }) => (
        <label key={key}>
          {label}
          <select value={filters[key]} onChange={event => updateFilters({ [key]: event.target.value })}>
            {options.map(([value, display]) => (
              <option key={value} value={value}>
                {display}
              </option>
            ))}
          </select>
        </label>
      ))}
      <SalesAndPromotionsDateRangePicker
        fromDate={filters.fromDate}
        toDate={filters.toDate}
        onApply={(fromDate, toDate) => updateFilters({ fromDate, toDate, status: fromDate ? 'all' : 'current' })}
      />
      <span className='sort-label'>Newest added first</span>
    </div>
    {filters.fromDate && <p className='date-filter-hint'>Showing sales active during this date range (Eastern time).</p>}
  </div>
);
SalesAndPromotionsPanelControls.propTypes = {
  filters: PropTypes.object.isRequired,
  updateFilters: PropTypes.func.isRequired
};
export default SalesAndPromotionsPanelControls;
